export enum DATA_TEST {
  admin_settings_divider = 'admin_settings_divider',
  admin_settings_icon = 'admin_settings_icon',
  app_switcher_container = 'app_switcher_container',
  app_switcher_close_icon = 'app_switcher_close_icon',
  app_switcher_item = 'app_switcher_item',
  app_switcher_selection_dialog_container = 'app_switcher_selection_dialog_container',
  app_switcher_selection_dialog_card = 'app_switcher_selection_dialog_card',
  app_switcher_selection_dialog_card_check_icon = 'app_switcher_selection_dialog_card_check_icon',
  app_switcher_selection_dialog_cancel_button = 'app_switcher_selection_dialog_cancel_button',
  app_switcher_selection_dialog_continue_button = 'app_switcher_selection_dialog_continue_button',
  badge_notification = 'badge_notification',
  chevron_right_icon = 'chevron_right_icon',
  context_switcher_trigger = 'context_switcher_trigger',
  context_switcher_container = 'context_switcher_container',
  context_switcher_dropdown_arrow = 'context_switcher_dropdown_arrow',
  context_switcher_loading = 'context_switcher_loading',
  context_switcher_error = 'context_switcher_error',
  context_switcher_more_item_tooltip = 'context_switcher_more_item_tooltip',
  context_switcher_tooltip = 'context_switcher_tooltip',
  counter_adornment = 'counter_adornment',
  create_new_action_button = 'create_new_action_button',
  create_new_action_button_group = 'create_new_action_button_group',
  create_new_action_dropdown_button = 'create_new_action_dropdown_button',
  create_new_action_submenu = 'create_new_action_submenu',
  delete_item = 'delete_item',
  desktop_utility_tray_container = 'desktop_utility_tray_container',
  desktop_utility_tray_options = 'desktop_utility_tray_options',
  entity_switcher_dialog_container = 'entity_switcher_dialog_container',
  entity_autocomplete = 'entity_autocomplete',
  entity_autocomplete_list_item = 'entity_autocomplete_list_item',
  entity_autocomplete_search_input = 'entity_autocomplete_search_input',
  entity_chip = 'entity_chip',
  entity_loading_error = 'entity_loading_error',
  entity_selected_check_mark = 'entity_selected_check_mark',
  entity_switcher_cancel_icon = 'entity_switcher_cancel_icon',
  empty_favorites_view = 'empty_favorites_view',
  entity_switcher_custom_logo = 'entity_switcher_custom_logo',
  entity_switcher_default_logo = 'entity_switcher_default_logo',
  entity_switcher_selection_dialog_container = 'entity_switcher_selection_dialog_container',
  entity_switcher_selection_dialog_container_mobile = 'entity_switcher_dialog_container_mobile',
  entity_switcher_selection_dialog_option = 'entity_switcher_selection_dialog_option',
  entity_switcher_open_dialog_option = 'entity_switcher_open_dialog_option',
  entity_switcher_selection_dialog_cancel_button = 'entity_switcher_selection_dialog_cancel_button',
  entity_switcher_selection_dialog_continue_button = 'entity_switcher_selection_dialog_continue_button',
  entity_switcher_selection_dialog_selected_icon = 'entity_switcher_selection_dialog_selected_icon',
  expand_more_icon = 'expand_more_icon',
  expand_more_icon_selected = 'expand_more_icon_selected',
  favorite_error_toast = 'favorite_error_toast',
  favorites_display_grid = 'favorites_display_grid',
  favorites_favorited_icon = 'favorites_favorited_icon',
  favorites_submenu_container = 'favorites_submenu_container',
  favorites_text_instructions = 'favorites_text_instructions',
  global_search_input = 'global_search_input',
  global_search_clear = 'global_search_clear',
  global_search_close = 'global_search_close',
  global_search_filter_button = 'global_search_filter_button',
  global_search_row = 'global_search_row',
  handle_sign_out = 'handle_sign_out',
  icon_utility_submenu = 'icon_utility_submenu',
  initial_active_entity_button = 'initial_active_entity_button',
  level_one_more_items_tooltip = 'level_one_more_items_tooltip',
  level_one_item_label = 'level_one_item_label',
  level_one_item_link = 'level_one_item_link',
  level_three_error_state = 'level_three_error_state',
  level_two_loading_menu = 'level_two_loading_menu',
  level_three_loading_menu = 'level_three_loading_menu',
  loading_block_indicator = 'loading_block_indicator',
  menu_loading_indicator = 'menu_loading_indicator',
  mobile_active_product_icon = 'mobile_active_product_icon',
  mobile_back_button = 'mobile_back_button',
  mobile_chevron_right_icon = 'mobile_chevron_right_icon',
  mobile_app_name = 'mobile_app_name',
  mobile_app_switcher_button = 'mobile_app_switcher_button',
  mobile_app_switcher_collapse = 'mobile_app_switcher_collapse',
  mobile_context_switcher_button = 'mobile_context_switcher_button',
  mobile_entity_switcher_menu_item = 'mobile_entity_switcher_menu_item',
  mobile_entity_switcher_icon = 'mobile_entity_switcher_icon',
  mobile_level_one_link = 'mobile_level_one_link',
  mobile_level_one_favorites = 'mobile_level_one_favorites',
  mobile_level_one_item = 'mobile_level_one_item',
  mobile_level_three_link = 'mobile_level_three_link',
  mobile_level_three_item = 'mobile_level_three_item',
  mobile_level_three_error_view = 'mobile_level_three_error_view',
  mobile_level_three_loading_menu = 'mobile_level_three_loading_menu',
  mobile_level_two_error_view = 'mobile_level_two_error_view',
  mobile_level_two_loading_menu = 'mobile_level_two_loading_menu',
  mobile_level_two_link = 'mobile_level_two_link',
  mobile_level_two_item = 'mobile_level_two_item',
  mobile_menu_button = 'mobile_menu_button',
  mobile_menu_button_close = 'mobile_menu_button_close',
  mobile_menu_button_menu = 'mobile_menu_button_menu',
  mobile_menu_container = 'mobile_menu_container',
  mobile_menu_item_link = 'mobile_menu_item_link',
  mobile_menu_item_label = 'mobile_menu_item_label',
  mobile_nav_bar_container = 'mobile_nav_bar_container',
  mobile_switch_menu_container = 'mobile_switch_menu_container',
  mobile_utility_main_menu_container = 'mobile_utility_main_menu_container',
  mobile_utility_options_button = 'mobile_utility_options_button',
  mobile_utility_tray_container = 'mobile_utility_tray_container',
  mobile_utility_tray = 'mobile_utility_tray',
  mobile_favorites_container = 'mobile_favorites_container',
  mobile_level_one_switch_menu = 'mobile_level_one_switch_menu',
  more_menu_container = 'more_menu_container',
  more_menu_tooltip = 'more_menu_tooltip',
  more_menu_item = 'more_menu_item',
  more_top_level_menu_item = 'more_top_level_menu_item',
  nav_app_name_container = 'nav_app_name_container',
  nav_bar_and_submenu_container = 'nav_bar_and_submenu_container',
  nav_bar_header = 'nav_bar_header',
  nav_icon_opengov = 'nav_icon_opengov',
  nav_icon_opengov_mobile = 'nav_icon_opengov_mobile',
  nav_menu_container = 'nav_menu_container',
  nav_utilities_container = 'nav_utilities_container',
  offline_indicator = 'offline_indicator',
  opengov_logo = 'opengov_logo',
  opengov_logo_link = 'opengov_logo_link',
  product_icon = 'product_icon',
  popper_more_menu_container = 'popper_more_menu_container',
  profile_button = 'profile_button',
  profile_div = 'profile_div',
  profile_settings_option = 'profile_settings_option',
  profile_settings_option_container = 'profile_settings_option_container',
  profile_utility_tray_submenu = 'profile_utility_tray_submenu',
  submenu_item_overflow_tooltip = 'submenu_item_overflow_tooltip',
  main_submenu_container = 'main_submenu_container',
  submenu_level_two_error_state = 'submenu_level_two_error_state',
  submenu_level_three_container = 'submenu_level_three_container',
  submenu_level_two_container = 'submenu_level_two_container',
  switch_menu_item_container = 'switch_menu_item_container',
  switch_menu_item = 'switch_menu_item',
  switch_menu_submenu = 'switch_menu_submenu',
  right_arrow_icon = 'right_arrow_icon',
  draggable_favorites = 'draggable_favorites',
  favorites_item = 'favorites_item',
  favorites_section = 'favorites_section',
  favorite_star_button = 'favorite_star_button',
  favorite_star_button_filled = 'favorite_star_button_filled',
  favorite_star_button_outline = 'favorite_star_button_outline',
  favorites_section_container = 'favorites_section_container',
  search_action_button = 'search_action_button',
  submenu_level_three_container_section = 'submenu_level_three_container_section',
  submenu_item = 'submenu_item',
  mobile_utility_menu_item_link = 'mobile_utility_menu_item_link',
  mobile_utility_menu_item = 'mobile_utility_menu_item',
  my_profile_link = 'my_profile_link',
  tray_controller_button = 'tray_controller_button',
  tray_icon_link = 'tray_icon_link',
  tray_option_container = 'tray_option_container',
  tray_option_mui_icon = 'tray_option_mui_icon',
  tray_option_custom_icon = 'tray_option_custom_icon',
  utility_tray_menu_item_link = 'utility_tray_menu_item_link',
  utility_tray_menu_item = 'utility_tray_menu_item',
  utility_tray_profile_submenu = 'utility_tray_profile_submenu',
  mobile_utility_submenu_container = 'mobile_utility_submenu_container',
  toast_close_button = 'toast_close_button',
  toast_icon = 'toast_icon',
  og_assist_button = 'og_assist_button',
  og_assist_menu = 'og_assist_menu',
  og_assist_loading_spinner = 'og_assist_loading_spinner',
  og_assist_loading_text = 'og_assist_loading_text',
  chat_thread_header = 'chat_thread_header'
}

export enum DATA_OG {
  app_switcher_item = 'app_switcher_item',
  app_switcher_close_icon = 'app_switcher_close_icon',
  app_switcher_selection_dialog_cancel_button = 'app_switcher_selection_dialog_cancel_button',
  app_switcher_selection_dialog_continue_button = 'app_switcher_selection_dialog_continue_button',
  context_switcher_container = 'context_switcher_container',
  create_new_action_button = 'create_new_action_button',
  create_new_action_dropdown_button = 'create_new_action_dropdown_button',
  entity_switcher_dialog_container = 'entity_switcher_dialog_container',
  entity_switcher_selection_dialog_cancel_button = 'entity_switcher_selection_dialog_cancel_button',
  entity_switcher_selection_dialog_continue_button = 'entity_switcher_selection_dialog_continue_button',
  entity_switcher_cancel_icon = 'entity_switcher_cancel_icon',
  entity_switcher_selection_dialog_option = 'entity_switcher_selection_dialog_option',
  entity_switcher_open_dialog_option = 'entity_switcher_open_dialog_option',
  handle_sign_out = 'handle_sign_out',
  menu_item = 'menu_item',
  my_profile_link = 'my_profile_link',
  offline_indicator = 'offline_indicator',
  mobile_menu_button = 'mobile_menu_button',
  profile_button = 'profile_button',
  profile_div = 'profile_div',
  profile_settings_option = 'profile_settings_option',
  search_action_button = 'search_action_button',
  switch_menu_item = 'switch_menu_item',
  tray_controller_button = 'tray_controller_button',
  tray_icon_link = 'tray_icon_link',
  utility_tray_menu_item_link = 'utility_tray_menu_item_link',
  mobile_utility_menu_link = 'mobile_utility_menu_link'
}

export const getDynamicDataOGId = (key: DATA_OG, identifier: string): string => {
  if (Object.values(DATA_OG).includes(key)) return `${key}_${identifier}`;
  throw new Error('Invalid key');
};

export const getDynamicDataTestId = (key: DATA_TEST, identifier: string): string => {
  if (Object.values(DATA_TEST).includes(key)) return `${key}_${identifier}`;
  throw new Error('Invalid key');
};
